/* eslint-disable react/prop-types */
import React from 'react';
import ErrorPage from './ErrorPage';
import * as Sentry from '@sentry/react';

type State = {
  error: string;
};
type ErrorType = {
  name: string;
  message: string;
};

type ErrorBoundaryProps = {
  children: React.ReactNode;
  fallback?: React.ReactNode;
};

class ErrorBoundary extends React.Component<ErrorBoundaryProps> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { error: '' };
  }

  componentDidCatch(error: ErrorType): void {
    this.setState({ error: `${error.name}: ${error.message}` });
    // Capture the exception in Sentry
    const eventId = Sentry.captureException(error);

    // Show the Sentry report dialog only in non-local environments
    if (eventId && process.env.NODE_ENV !== 'development') {
      // console.log(Sentry.eventFromException);
      Sentry.showReportDialog({ eventId });
    }
  }

  render(): React.ReactElement {
    const { error } = this.state as State;
    if (error) {
      return <>{this.props.fallback}</> || <ErrorPage />;
    } else {
      return <>{this.props.children}</>;
    }
  }
}

export default ErrorBoundary;
